import Staff from '@/interfaces/Staff';
import IEstablishment from '@/interfaces/IEstablishment';
import EPage from '@/enums/EPages';
import EBasicActions from '@/enums/EBasicActions';
import { getStaffRelatedEstablishment } from '@/services/Staff';
import hasStoredAccess from '@/shared/helpers/hasStoredAccess';

/**
 * Establishment scoping rule shared by `EstablishmentGuard` (`/establishments/:id`) and the
 * dashboard (establishment picked in-page): the signed-in staff must be related to the
 * establishment it is trying to read, unless it holds the `establishments_manager` action,
 * which grants access to every establishment.
 */
const canAccessEstablishment = async (
  userId?: Staff['id'],
  email?: Staff['email'],
  establishmentId?: IEstablishment['id'],
): Promise<boolean> => {
  if (!userId || !establishmentId) return false;

  if (hasStoredAccess(EPage.EstablishmentsManager, EBasicActions.Get)) return true;

  try {
    const related = await getStaffRelatedEstablishment({ userId, establishmentId });
    return related.length > 0 ? related[0].email === email : false;
  } catch {
    return false;
  }
};

export default canAccessEstablishment;
